import { Close, Download, SimCardDownload, SimCardDownloadTwoTone } from "@mui/icons-material";
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Fade, IconButton, Modal, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { getFile, getFileDirect } from "../apis/file.api";
import fileDownload from 'js-file-download'

const FileDownloadComponent = ({ text, src, direct, heades = false, fileString, fileNameDefault }) => {
    const [loading, setLoading] = useState(false)
    const filePath = src ? src.split('/') : []
    const fileName = fileNameDefault ?? filePath[filePath.length - 1]
    const fileNameSPlitted = fileName?.split('.')
    const fileExetensiontmp = fileNameSPlitted[fileNameSPlitted?.length - 1]
    const fileExetension = fileExetensiontmp?.split("?")?.[0]
    const fetchImage = async () => {
        setLoading(true)

        if (fileString) {
            const downloadLink = document.createElement("a");
            downloadLink.href = 'data:' + fileString.mimetype + ';base64,' + fileString.buffer;
            downloadLink.download = fileName;
            downloadLink.click()
            // fileDownload('data:'+fileString.mimetype+';base64,'+fileString.buffer,fileString.originalname)
            setLoading(false)
            return
        }
        const file = direct ? await getFileDirect(src, heades) : await getFile(src)

        fileDownload(file, (fileNameDefault?.split?.('.')?.[0] ?? (text ?? fileName)) + (!direct && fileExetension ? ("." + fileExetension) : '.pdf'))



        setLoading(false)
    }



    if (loading)
        return <CircularProgress />
    if (text)
        return <Button size="small" onClick={fetchImage}>{text}</Button>
    return (

        <>
            <IconButton onClick={fetchImage} ><SimCardDownload /></IconButton>

        </>)
}
export default FileDownloadComponent